import { render, staticRenderFns } from "./CountIndicator.vue?vue&type=template&id=5e2b8b3c"
import script from "./CountIndicator.vue?vue&type=script&lang=js"
export * from "./CountIndicator.vue?vue&type=script&lang=js"
import style0 from "./CountIndicator.vue?vue&type=style&index=0&id=5e2b8b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports